/**
 * Shell tipo app para movil: drawer (compartido entre la hamburguesa del
 * header y el tab "Categorias" de la barra inferior), boton de carrito de
 * la barra inferior, y el toggle del buscador del header. Ver
 * snippets/rechilero-mobile-nav.liquid y sections/rechilero-header.liquid.
 *
 * trapFocus/removeTrapFocus vienen de global.js (assets/global.js), que
 * carga antes que este script (ambos "defer", el orden lo da el orden en
 * el documento -- ver layout/theme.liquid).
 */
(function () {
  const nav = document.querySelector('[data-rechilero-mobile-nav]');
  if (!nav) return;

  const backdrop = nav.querySelector('[data-rechilero-drawer-backdrop]');
  const panel = nav.querySelector('.rechilero-drawer__panel');
  let lastFocused = null;
  let closeTimer = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    window.clearTimeout(closeTimer);
    backdrop.hidden = false;
    panel.hidden = false;
    // Forzar reflow para que la transicion de transform corra (si se
    // agrega la clase en el mismo tick que se saca "hidden", el navegador
    // puede saltarse la animacion).
    void panel.offsetWidth;
    panel.classList.add('rechilero-drawer__panel--open');
    document.body.classList.add('overflow-hidden');
    trapFocus(panel);
  }

  function closeDrawer() {
    if (panel.hidden) return;
    panel.classList.remove('rechilero-drawer__panel--open');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(lastFocused);
    // Recien se sacan del flujo (hidden) cuando termina la transicion de
    // salida, si no el panel desaparece de golpe en vez de deslizarse.
    closeTimer = window.setTimeout(() => {
      backdrop.hidden = true;
      panel.hidden = true;
    }, 250);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-rechilero-drawer-open]')) {
      event.preventDefault();
      openDrawer();
    } else if (
      event.target.closest('[data-rechilero-drawer-close]') ||
      event.target.closest('[data-rechilero-drawer-backdrop]')
    ) {
      closeDrawer();
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape' && panel.classList.contains('rechilero-drawer__panel--open')) {
      closeDrawer();
    }
  });

  // Paneles inferiores de los chips con subcategorias (Tecnologia, Marcas)
  // -- ver sections/rechilero-header.liquid y snippets/rechilero-mobile-nav.liquid.
  let openSheet = null;
  let sheetTimer = null;

  function openChipSheet(id) {
    const sheet = document.getElementById(id);
    if (!sheet) return;
    window.clearTimeout(sheetTimer);
    if (openSheet && openSheet !== sheet) openSheet.hidden = true;
    openSheet = sheet;
    sheet.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add('rechilero-chip-sheet--open');
    document.body.classList.add('overflow-hidden');
  }

  function closeChipSheet() {
    if (!openSheet) return;
    const sheet = openSheet;
    openSheet = null;
    sheet.classList.remove('rechilero-chip-sheet--open');
    document.body.classList.remove('overflow-hidden');
    sheetTimer = window.setTimeout(() => {
      sheet.hidden = true;
    }, 250);
  }

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-rechilero-chip-sheet]');
    if (chip) {
      openChipSheet(chip.dataset.rechileroChipSheet);
    } else if (event.target.closest('[data-rechilero-sheet-close]')) {
      closeChipSheet();
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') closeChipSheet();
  });

  // Barra inferior que se esconde al bajar y reaparece al subir un poco
  // (como Facebook). Umbrales: ignora micro-movimientos, siempre visible
  // cerca del tope de la pagina y al llegar al final.
  const tabbar = nav.querySelector('.rechilero-tabbar');
  if (tabbar) {
    let lastY = window.scrollY;
    let ticking = false;

    function updateTabbar() {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      const nearTop = y < 60;
      const nearBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 4;

      if (nearTop || nearBottom) {
        tabbar.classList.remove('rechilero-tabbar--hidden');
      } else if (delta > 8) {
        tabbar.classList.add('rechilero-tabbar--hidden');
      } else if (delta < -6) {
        tabbar.classList.remove('rechilero-tabbar--hidden');
      }
      if (Math.abs(delta) > 6) lastY = y;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateTabbar);
        }
      },
      { passive: true }
    );
  }

  // Carrito de la barra inferior: reenvia el click al elemento REAL del
  // header (id="cart-icon-bubble") en vez de duplicar ese id -- Dawn y
  // varios scripts propios (cart-drawer.js, cart.js, etc.) lo buscan por
  // ese nombre para abrir el drawer y refrescar el contador tras cada
  // compra; un segundo elemento con el mismo id rompe uno de los dos.
  const tabbarCartBtn = nav.querySelector('[data-rechilero-tabbar-cart]');
  const tabbarBadge = nav.querySelector('[data-rechilero-tabbar-cart-badge]');
  const realCartLink = document.getElementById('cart-icon-bubble');

  if (tabbarCartBtn && realCartLink) {
    tabbarCartBtn.addEventListener('click', () => realCartLink.click());

    const syncBadge = () => {
      const countEl = realCartLink.querySelector('.rechilero-cart-badge span[aria-hidden]');
      const count = countEl ? countEl.textContent.trim() : '';
      tabbarBadge.textContent = count || '0';
      tabbarBadge.hidden = !count || count === '0';
    };

    syncBadge();
    // El evento pubsub "cart-update" NO se dispara en el flujo normal de
    // compra (product-form.js actualiza el DOM directo) -- se refleja el
    // badge observando mutaciones del elemento real, que es el unico
    // punto por el que pasan todos los caminos de agregar/quitar.
    new MutationObserver(syncBadge).observe(realCartLink, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // Buscador del header en movil -- ver sections/rechilero-header.liquid.
  // <predictive-search> es un custom element persistente: mostrar/ocultar
  // su contenedor por CSS no le borra el estado interno, asi que al
  // cerrar se llama a su propio .close() ademas de ocultar por CSS.
  const searchToggle = document.querySelector('[data-rechilero-search-toggle]');
  const searchPanel = document.querySelector('.rechilero-header__search-panel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', () => {
      const isOpen = searchPanel.classList.toggle('rechilero-header__search-panel--open');
      searchToggle.setAttribute('aria-expanded', String(isOpen));
      const input = searchPanel.querySelector('input[type="search"]');
      if (isOpen) {
        window.setTimeout(() => input && input.focus(), 50);
      } else {
        const predictiveSearch = searchPanel.querySelector('predictive-search');
        if (predictiveSearch && typeof predictiveSearch.close === 'function') predictiveSearch.close();
        if (input) input.blur();
      }
    });
  }

  // Buscador siempre visible (barra tipo app): tocar cualquier parte de la
  // pastilla enfoca el campo para que abra el teclado, incluso si el toque
  // cae en el padding y no sobre el <input> mismo.
  if (searchPanel) {
    const searchInput = searchPanel.querySelector('input[type="search"]');
    searchPanel.addEventListener('click', (event) => {
      if (searchInput && !event.target.closest('button, a, li')) searchInput.focus();
    });
  }
})();
